import momentTz from 'moment-timezone';

/**
 * Get the user's browser timezone
 */
export const getTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Get the abbreviation for a given timezone (e.g., 'EST', 'PST')
 */
export const getTimezoneAbbr = (timeZone: string): string =>
  momentTz.tz(timeZone).zoneAbbr();

/**
 * Get the UTC offset string for a given timezone (e.g., 'UTC+1', 'UTC-5:30')
 */
export const getTimezoneUtcOffsetStr = (timeZone: string): string => {
  const offsetMinutes = momentTz.tz(timeZone).utcOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  return minutes > 0
    ? `UTC${sign}${hours}:${String(minutes).padStart(2, '0')}`
    : `UTC${sign}${hours}`;
};

/**
 * Get the user's locale if en-US else 'en-GB'
 */
export const getLocale = (): string =>
  `${navigator.language}`.toLowerCase() === 'en-us'
    ? navigator.language
    : 'en-GB';
